import React from 'react';
import { Check, Shield, Users, HeartHandshake, Wallet } from 'lucide-react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: <Shield size={20} />,
      title: 'Advanced Technology',
      desc: 'Equipped with the latest medical equipment and diagnostic tools for accurate treatment.',
    },
    {
      icon: <Users size={20} />,
      title: 'Expert Medical Team',
      desc: 'Our doctors are highly qualified with years of experience in their respective specialties.',
    },
    {
      icon: <HeartHandshake size={20} />,
      title: 'Patient-Centered Care',
      desc: 'We prioritize your comfort and well-being throughout your healthcare journey.',
    },
    {
      icon: <Wallet size={20} />,
      title: 'Affordable Healthcare',
      desc: 'Quality medical services at transparent and reasonable pricing for everyone.',
    },
  ];

  return (
    <div className="about-page">
      <section className="section">
        <div className="about-grid">
          <div className="about-left">
            <img
              className="about-img-main"
              src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=600&h=500&fit=crop"
              alt="Clinic Interior"
            />
            <div className="about-experience">
              <h3>15+</h3>
              <p>Years of Excellence</p>
            </div>
          </div>
          <div className="about-right">
            <h2>About RV Clinic</h2>
            <p>RV Clinic has been a beacon of healthcare excellence for over 15 years. We combine modern medical technology with compassionate care to deliver outstanding patient outcomes.</p>
            <div className="feature-list">
              {features.map((feature, i) => (
                <div className="feature-item" key={i}>
                  <div className="feature-check">{feature.icon}</div>
                  <div>
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
